export const toastConfig = {
	position: "bottom-center",
	toastIds: {
		errNetwork: "errNetwork",
		errUserService: "errUserService",
		errLoad: "errLoad",
		errSave: "errSave",
		errLogin: "errLogin",
		warnUnsupportedApp: "Unsupported app",
	},
};
